namespace advisorop.components.servicer {

    export class AccountMappingListServicerController { 
        $router;

        public accounts;
        public dg: DevExpress.ui.dxDataGridOptions;
        companyGroup: domains.ICompanyGroup;
        companyGroupId: number;

        static $inject = ["advisorService", "generalService", "servicerService"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService, private servicerService: services.ServicerService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Accounts"
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "There are currently no accounts that need to be mapped",
                stateStoring: {
                    enabled: false,
                    type: "localStorage",
                    storageKey: "dgAccountsXY"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountID', caption: 'Account', width: 120 },                    
                    { dataField: 'acctName', caption: 'Name' },
                    { dataField: 'acctType', caption: 'PP Type', width: 50 },                    
                    { dataField: 'openDate', caption: 'Opened', headerCellTemplate: (h, info) => { $(h).attr("title", "Sourced from Orion").append($("<span>").text(info.column.caption || "")); }, dataType: 'date', format: 'shortDate', width: 90 },
                    { dataField: 'closedDate', caption: 'Closed', dataType: 'date', format: 'shortDate', width: 90 },
                    { dataField: 'rtgName', caption: 'PP Household', width: 150 },
                    { dataField: 'accountID', caption: '#', cellTemplate: 'btnActions', width: 160 }
                ],
                //selection: {
                //    mode: 'single',
                //    showCheckBoxesMode: 'onClick'
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onInvestorChanged({ id: data.id });
                //    }
                //}
            };
        }

        loadUnmappedAccounts(): void {
            console.log(this.companyGroup);
            var rez = this.servicerService.getUnmappedAccounts(this.companyGroup.ppFirmId);

            rez.then((data) => {
                this.accounts = data.data;
            }).catch((data) => {
                toastr.error("Error " + data.status + " " + data.data);
            });
        };


        $onInit(): void {
            if (this.companyGroup != null) {
                //console.log("Log in list servicer");
                //console.log(this.companyGroup);
                this.companyGroupId = this.companyGroup.id;
                this.loadUnmappedAccounts();
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "companyGroup") {
                    if (this.companyGroup) {
                        this.companyGroup = this.companyGroup;
                        this.$onInit();
                    }
                    
                }
            }
        }
        
    }
    
    class AccountMappingListServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<",
               // accounts: "<",
                companyGroup: "<"
            };
            this.controller =  AccountMappingListServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/account-mapping-list-servicer.html';
        }
    }
    angular.module(Constants.APP).component("accountMappingListServicer", new AccountMappingListServicer());
}